import { render, staticRenderFns } from "./loginLayout.vue?vue&type=template&id=e37d1b96&scoped=true&"
import script from "./loginLayout.vue?vue&type=script&lang=js&"
export * from "./loginLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e37d1b96",
  null
  
)

export default component.exports